import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';

import { setFilterAction } from 'store/pushNotifications/actions';
import { selectPushNotificationFilters } from 'store/pushNotifications/selectors';

import FilterChip from './FilterChip';
import {
  NOTIFICATION_SOURCE_FILTER_OPTIONS,
  NOTIFICATION_TYPE_FILTER_OPTIONS,
} from './PushNotificationFilterBar.constants';
import {
  filterBarStyles,
  filterLabelStyles,
  filterRowStyles,
} from './PushNotificationFilterBar.styles';
import { PushNotificationFilterBarTestIds } from './PushNotificationFilterBar.testIds';

const PushNotificationFilterBar = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectPushNotificationFilters);

  const onTypeChange = useCallback(
    value => {
      if (filters.type === value) {
        return;
      }

      dispatch(setFilterAction({ type: value }));
    },
    [dispatch, filters.type],
  );

  const onSourceChange = useCallback(
    value => {
      if (filters.source === value) {
        return;
      }

      dispatch(setFilterAction({ source: value }));
    },
    [dispatch, filters.source],
  );

  return (
    <Box sx={filterBarStyles}>
      <Box sx={filterRowStyles}>
        <Typography sx={filterLabelStyles} variant="regular12">
          Type
        </Typography>
        {NOTIFICATION_TYPE_FILTER_OPTIONS.map(option => (
          <FilterChip
            dataTestId={PushNotificationFilterBarTestIds.getTypeChipId(option.value)}
            isSelected={filters.type === option.value}
            key={option.value}
            label={option.label}
            value={option.value}
            onSelect={onTypeChange}
          />
        ))}
      </Box>

      <Box sx={filterRowStyles}>
        <Typography sx={filterLabelStyles} variant="regular12">
          Source
        </Typography>
        {NOTIFICATION_SOURCE_FILTER_OPTIONS.map(option => (
          <FilterChip
            dataTestId={PushNotificationFilterBarTestIds.getSourceChipId(option.value)}
            isSelected={filters.source === option.value}
            key={option.value}
            label={option.label}
            value={option.value}
            onSelect={onSourceChange}
          />
        ))}
      </Box>
    </Box>
  );
};

export default memo(PushNotificationFilterBar);
